import { render, staticRenderFns } from "./PropertiesFilter.vue?vue&type=template&id=2fa9f475&scoped=true"
import script from "./PropertiesFilter.vue?vue&type=script&lang=ts"
export * from "./PropertiesFilter.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesFilter.vue?vue&type=style&index=0&id=2fa9f475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9f475",
  null
  
)

export default component.exports